(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-collection-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  const allowedSorts=new Set(['manual','best-selling','created-descending','price-ascending','price-descending']);
  let controller=null, sequence=0, priceTimer;
  const canonical=(value)=>{
    const target=new URL(value,location.href);
    if(!allowedSorts.has(target.searchParams.get('sort_by')))target.searchParams.set('sort_by','best-selling');
    const current=new URL(location.href);
    ['preview_theme_id','view'].forEach(key=>{if(current.searchParams.has(key)&&!target.searchParams.has(key))target.searchParams.set(key,current.searchParams.get(key));});
    return target;
  };
  const init=(scope)=>{
    if(!scope||scope.dataset.collectionReady)return;
    scope.dataset.collectionReady='true';
    const disclosure=scope.querySelector('[data-mm-browse-disclosure]');
    if(disclosure)disclosure.open=!matchMedia('(max-width:1024px)').matches;
  };
  const navigate=async(value,{push=true,page=false,initial=false}={})=>{
    const scope=document.querySelector('[data-mm-collection]');if(!scope)return;
    const target=canonical(value),sectionTarget=new URL(target);
    sectionTarget.searchParams.set('section_id',scope.dataset.sectionId);
    const active=document.activeElement;
    const focusState=scope.contains(active)?{name:active.name,value:active.value,facet:active.closest('[data-mm-facet]')?.dataset.mmFacet,disclosure:active===scope.querySelector('[data-mm-browse-disclosure]>summary')}:null;
    const openFacets=[...scope.querySelectorAll('[data-mm-facet][open]')].map(el=>el.dataset.mmFacet);
    const disclosureOpen=scope.querySelector('[data-mm-browse-disclosure]')?.open;
    controller?.abort();controller=new AbortController();const request=++sequence;
    scope.setAttribute('aria-busy','true');scope.querySelector('[data-mm-collection-status]').textContent=scope.dataset.loadingMessage;
    try{
      const response=await fetch(sectionTarget,{signal:controller.signal});if(!response.ok)throw new Error('Request failed');
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      const replacement=parsed.querySelector('[data-mm-collection]');if(!replacement)throw new Error('Missing collection');
      if(request!==sequence)return;
      scope.replaceWith(replacement);init(replacement);
      replacement.querySelector('[data-mm-browse-disclosure]').open=disclosureOpen;
      replacement.querySelectorAll('[data-mm-facet]').forEach(el=>el.open=openFacets.includes(el.dataset.mmFacet));
      if(push)history.pushState({},'',target);else if(initial)history.replaceState({},'',target);
      if(page){replacement.querySelector('[data-mm-collection-status]').focus({preventScroll:true});replacement.querySelector('[data-mm-collection-status]').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
      else if(focusState){
        const focus=[...replacement.querySelectorAll('input,select')].find(el=>el.name===focusState.name&&(el.type!=='checkbox'||el.value===focusState.value));
        if(focus&&!focus.disabled)focus.focus({preventScroll:true});
        else if(focusState.facet)[...replacement.querySelectorAll('[data-mm-facet]')].find(el=>el.dataset.mmFacet===focusState.facet)?.querySelector('summary').focus({preventScroll:true});
        else replacement.querySelector('[data-mm-collection-status]').focus({preventScroll:true});
      }
      document.dispatchEvent(new CustomEvent('mm:collection:updated',{detail:{section:replacement}}));
    }catch(error){if(error.name==='AbortError')return;scope.removeAttribute('aria-busy');scope.querySelector('[data-mm-collection-status]').textContent=scope.dataset.errorMessage;}
  };
  const formUrl=(form)=>{
    const target=canonical(form.action);target.searchParams.delete('page');
    [...target.searchParams.keys()].forEach(key=>{if(key.startsWith('filter.'))target.searchParams.delete(key);});
    for(const [key,value] of new FormData(form)){if(String(value).trim())target.searchParams.append(key,value);}
    const sort=form.querySelector('[name=sort_by]');if(sort)target.searchParams.set('sort_by',sort.value);
    return target;
  };
  document.addEventListener('change',event=>{const form=event.target.closest('[data-mm-collection-form]');if(form&&form.reportValidity()){clearTimeout(priceTimer);navigate(formUrl(form));}});
  document.addEventListener('input',event=>{const form=event.target.closest('[data-mm-collection-form]');if(form&&event.target.type==='number'){clearTimeout(priceTimer);priceTimer=setTimeout(()=>{if(form.checkValidity())navigate(formUrl(form));},650);}});
  document.addEventListener('submit',event=>{if(event.target.matches('[data-mm-collection-form]')){event.preventDefault();clearTimeout(priceTimer);if(event.target.reportValidity())navigate(formUrl(event.target));}});
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-mm-collection-link]');
    if(link&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey&&event.button===0){event.preventDefault();navigate(link.href,{page:link.hasAttribute('data-mm-page-link')});}
    const scope=document.querySelector('[data-mm-collection]');
    scope?.querySelectorAll('[data-mm-facet][open]').forEach(el=>{if(!el.contains(event.target)&&!event.target.closest('[data-mm-facet]'))el.open=false;});
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const facet=event.target.closest('[data-mm-facet][open]');if(facet){facet.open=false;facet.querySelector('summary').focus();}}});
  matchMedia('(max-width:1024px)').addEventListener('change',event=>{const disclosure=document.querySelector('[data-mm-browse-disclosure]');if(disclosure)disclosure.open=!event.matches;});
  window.addEventListener('popstate',()=>{if(document.querySelector('[data-mm-collection]'))navigate(location.href,{push:false});});
  const boot=()=>{const scope=document.querySelector('[data-mm-collection]');init(scope);if(scope&&!allowedSorts.has(new URL(location.href).searchParams.get('sort_by')))navigate(location.href,{push:false,initial:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('[data-mm-collection]')));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-content-compare"] && !Shopify.designMode) return;
  try {
    function initialiseMilliesComparison(scope = document) {
  scope.querySelectorAll('[data-mm-compare]:not([data-ready])').forEach((root) => {
    const list = root.querySelector('[data-format-tabs]');
    const tabs = [...root.querySelectorAll('[data-format-tab]')];
    const panels = [...root.querySelectorAll('[data-format-panel]')];
    if (!list || !tabs.length || tabs.length !== panels.length) return;
    const select = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    };
    list.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
    select(0);
    list.hidden = false;
    root.dataset.ready = 'true';
  });
}
initialiseMilliesComparison();
document.addEventListener('shopify:section:load', (event) => initialiseMilliesComparison(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-cookie-banner-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const copy = document.getElementById('mm-cookie-banner-copy');
  if (!copy) return;
  const update = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;
    const title = banner.querySelector('#shopify-pc__banner__body-title');
    if (title && title.textContent !== copy.dataset.title) title.textContent = copy.dataset.title;
    const body = banner.querySelector('.shopify-pc__banner__body');
    if (body && !body.querySelector('.mm-cookie-eyebrow')) {
      const eyebrow = document.createElement('span');
      eyebrow.className = 'mm-cookie-eyebrow';
      eyebrow.textContent = copy.dataset.eyebrow;
      body.prepend(eyebrow);
    }
    for (const [id,key] of [['accept','accept'],['decline','reject'],['manage-prefs','manage']]) {
      const button = banner.querySelector('#shopify-pc__banner__btn-' + id);
      if (button && button.textContent !== copy.dataset[key]) button.textContent = copy.dataset[key];
    }
  };
  new MutationObserver(update).observe(document.body,{childList:true,subtree:true});
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-cookie-preferences"] && !Shopify.designMode) return;
  try {
    (() => {
  const form = document.querySelector('[data-mm-consent]');
  if (!form) return;
  const fields = form.querySelector('fieldset');
  const status = form.querySelector('[data-consent-status]');
  const retry = form.querySelector('[data-consent-retry]');
  const purposes = ['preferences', 'analytics', 'marketing'];
  let api, pending = false, loadVersion = 0;
  const message = (state, focus = false) => {
    status.dataset.state = state;
    status.textContent = form.dataset[state];
    if (focus) status.focus();
  };
  const sync = () => {
    const values = api.currentVisitorConsent();
    purposes.forEach(key => { form.elements[key].checked = values[key] === 'yes'; });
    return values;
  };
  const load = () => {
    const version = ++loadVersion;
    fields.disabled = true;
    retry.hidden = true;
    message('loading');
    let finished = false;
    const finish = error => {
      if (finished || version !== loadVersion) return;
      finished = true;
      clearTimeout(timer);
      api = window.Shopify?.customerPrivacy;
      try {
        if (error || !api?.currentVisitorConsent || !api?.setTrackingConsent) throw new Error();
        sync();
        fields.disabled = false;
        message('ready');
      } catch (_) { retry.hidden = false; message('error'); }
    };
    const timer = setTimeout(() => finish(true), 10000);
    try {
      if (window.Shopify?.customerPrivacy) finish(false);
      else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], finish);
      else finish(true);
    } catch (_) { finish(true); }
  };
  const save = values => {
    if (pending || fields.disabled || !api) return;
    pending = true;
    fields.disabled = true;
    message('saving');
    let finished = false;
    const finish = error => {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      pending = false;
      fields.disabled = false;
      try {
        const stored = api.currentVisitorConsent();
        if (error || !purposes.every(key => stored[key] === (values[key] ? 'yes' : 'no'))) throw new Error();
        sync();
        message('saved', true);
      } catch (_) { message('error', true); }
    };
    const timer = setTimeout(() => finish(true), 10000);
    try { api.setTrackingConsent(values, result => finish(Boolean(result?.error))); }
    catch (_) { finish(true); }
  };
  form.addEventListener('submit', event => {
    event.preventDefault();
    save(Object.fromEntries(purposes.map(key => [key, form.elements[key].checked])));
  });
  form.querySelector('[data-consent-reject]').addEventListener('click', () => save(Object.fromEntries(purposes.map(key => [key, false]))));
  form.querySelector('[data-consent-accept]').addEventListener('click', () => save(Object.fromEntries(purposes.map(key => [key, true]))));
  retry.addEventListener('click', load);
  document.addEventListener('visitorConsentCollected', () => { if (api && !pending) { try { sync(); } catch (_) {} } });
  load();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = () => {
    document.querySelectorAll('[data-mm-delivery-calendar]').forEach(panel => {
      const config = JSON.parse(panel.querySelector('[data-mm-delivery-config]').textContent);
      const form = panel.querySelector('[data-mm-delivery-postcode-form]');
      const dates = panel.querySelector('[data-mm-delivery-dates]');
      const message = panel.querySelector('[data-mm-delivery-message]');
      const list = value => String(value || '').split(/[\n,]+/).map(v => v.trim().toUpperCase()).filter(Boolean);
      const dispatchDays = list(config.dispatchDays).map(Number);
      const deliveryDays = list(config.deliveryDays).map(Number);
      const blackouts = new Set(list(config.blackouts));
      const areas = new Set(list(config.areas));
      const [cutoffHour, cutoffMinute] = String(config.cutoff).split(':').map(Number);
      const validDays = values => values.length && values.every(v => Number.isInteger(v) && v >= 0 && v <= 6);
      const validBlackouts = blackouts.size > 0 && [...blackouts].every(v => /^\d{4}-\d{2}-\d{2}$/.test(v) && !Number.isNaN(new Date(v).getTime()) && new Date(v).toISOString().slice(0,10) === v);
      const validRanges = ['handling','standard','express'].every(k => Number.isInteger(config[k+'Min']) && Number.isInteger(config[k+'Max']) && config[k+'Min'] >= 0 && config[k+'Max'] >= config[k+'Min'] && config[k+'Max'] <= 14);
      const configured = validDays(dispatchDays) && validDays(deliveryDays) && validBlackouts && validRanges && areas.size > 0 && Number.isInteger(cutoffHour) && cutoffHour >= 0 && cutoffHour < 24 && Number.isInteger(cutoffMinute) && cutoffMinute >= 0 && cutoffMinute < 60;
      let approvedPostcode = false;
      const key = date => date.toISOString().slice(0,10);
      const isDay = (date, days) => days.includes(date.getUTCDay()) && !blackouts.has(key(date));
      const addDays = (date, count, days) => {
        const next = new Date(date);
        for (let guard=0; count>0 && guard<730; guard++) { next.setUTCDate(next.getUTCDate()+1); if (isDay(next,days)) count--; }
        if (count > 0) throw new Error('No configured delivery day');
        return next;
      };
      const format = date => new Intl.DateTimeFormat('en-GB',{weekday:'short',day:'numeric',month:'short',timeZone:'UTC'}).format(date);
      const range = (min,max) => key(min) === key(max) ? format(min) : format(min)+' – '+format(max);
      const text = (value,replacements) => Object.entries(replacements).reduce((s,[k,v]) => s.replaceAll('__'+k.toUpperCase()+'__',String(v)),value);
      const update = () => {
        const product = panel.closest('[data-mm-product]');
        const selected = product?.querySelector('[data-mm-variant]');
        const available = !selected || !selected.options[selected.selectedIndex]?.disabled;
        panel.hidden = !available;
        if (!approvedPostcode || !configured || !available) { dates.hidden=true;return; }
        try {
          const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).map(p=>[p.type,p.value]));
          const today = new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day)));
          const minutes = Number(parts.hour)*60+Number(parts.minute);
          const cutoff = cutoffHour*60+cutoffMinute;
          const todayEligible = isDay(today,dispatchDays) && minutes < cutoff;
          const anchor = todayEligible ? today : addDays(today,1,dispatchDays);
          const dispatchMin = addDays(anchor,config.handlingMin,dispatchDays);
          const dispatchMax = addDays(anchor,config.handlingMax,dispatchDays);
          panel.querySelector('[data-mm-despatch-range]').textContent=range(dispatchMin,dispatchMax);
          panel.querySelector('[data-mm-standard-range]').textContent=range(addDays(dispatchMin,config.standardMin,deliveryDays),addDays(dispatchMax,config.standardMax,deliveryDays));
          panel.querySelector('[data-mm-express-range]').textContent=range(addDays(dispatchMin,config.expressMin,deliveryDays),addDays(dispatchMax,config.expressMax,deliveryDays));
          panel.querySelector('[data-mm-delivery-cutoff]').textContent=todayEligible ? text(config.messages.cutoff,{hours:Math.floor((cutoff-minutes)/60),minutes:(cutoff-minutes)%60,cutoff:config.cutoff}) : text(config.messages.next,{date:format(anchor)});
          dates.hidden=false;message.textContent='';
        } catch { dates.hidden=true;message.textContent=config.messages.unavailable; }
      };
      form.addEventListener('submit',event=>{
        event.preventDefault();
        const postcode=String(new FormData(form).get('delivery_postcode')||'').trim().toUpperCase().replace(/\s+/g,'');
        if (!/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(postcode)) { approvedPostcode=false;dates.hidden=true;message.textContent=config.messages.invalid;return; }
        const outward=postcode.slice(0,-3);
        approvedPostcode=configured && areas.has(outward);
        if (!approvedPostcode) { dates.hidden=true;message.textContent=config.messages.unavailable;return; }
        update();
      });
      panel.closest('[data-mm-product]')?.addEventListener('change',update);
      update();
      window.setInterval(()=>{if(!document.hidden)update();},60000);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise,{once:true});
  else initialise();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-gel-sticky-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise=()=>document.querySelectorAll('[data-mm-gel-sticky-purchase]').forEach(bar=>{
    if(bar.dataset.ready)return;bar.dataset.ready='true';
    const product=bar.closest('[data-mm-product]'),form=product.querySelector('.mm-product-form'),add=form?.querySelector('[data-mm-add]');
    if(!form||!add)return;
    const picks=[...bar.querySelectorAll('[data-mm-sticky-variant]')];
    picks.forEach(pick=>pick.addEventListener('click',()=>{const original=form.querySelector('[data-mm-variant]');original.value=pick.dataset.mmStickyVariant;original.dispatchEvent(new Event('change',{bubbles:true}));}));
    bar.querySelectorAll('[data-mm-sticky-mode]').forEach(pick=>pick.addEventListener('click',()=>{const original=form.querySelector('[name="mm_mode"][value="'+pick.dataset.mmStickyMode+'"]');if(!original||original.disabled)return;original.checked=true;original.dispatchEvent(new Event('change',{bubbles:true}));}));
    const stickyPlan=bar.querySelector('[data-mm-sticky-plan]');stickyPlan.addEventListener('change',()=>{const original=form.querySelector('[data-mm-plan]');original.value=stickyPlan.value;original.dispatchEvent(new Event('change',{bubbles:true}));});
    const button=bar.querySelector('[data-mm-sticky-add]'),summary=bar.querySelector('[data-mm-sticky-summary]');
    const sync=()=>{
      button.textContent=add.textContent;button.disabled=add.disabled;
      const variant=form.querySelector('[data-mm-variant]'),plan=form.querySelector('[data-mm-plan]'),quantity=form.querySelector('[name="quantity"]');
      picks.forEach(pick=>pick.setAttribute('aria-pressed',String(pick.dataset.mmStickyVariant===variant.value)));
      bar.querySelectorAll('[data-mm-sticky-mode]').forEach(pick=>{const mode=pick.dataset.mmStickyMode,original=form.querySelector('[name="mm_mode"][value="'+mode+'"]');pick.hidden=!original||original.closest('label').hidden;pick.disabled=!!original?.disabled;pick.setAttribute('aria-pressed',String(!!original?.checked));});
      bar.querySelector('[data-mm-sticky-once-price]').textContent=form.querySelector('[data-mm-once-price]')?.textContent||'';
      bar.querySelector('[data-mm-sticky-sub-price]').textContent=form.querySelector('[data-mm-sub-price]')?.textContent||'';
      bar.querySelector('[data-mm-sticky-plan-wrap]').hidden=!plan||plan.disabled;
      if(plan){if(stickyPlan.innerHTML!==plan.innerHTML)stickyPlan.innerHTML=plan.innerHTML;stickyPlan.value=plan.value;stickyPlan.disabled=plan.disabled;}

      const selected=JSON.parse(product.querySelector('[data-mm-product-data]').textContent).variants.find(item=>String(item.id)===variant?.value)?.title||'';
      const mode=form.querySelector('[name="mm_mode"]:checked')?.closest('label')?.querySelector('strong')?.textContent.trim()||'';
      summary.textContent=(quantity?.value||'1')+(selected?' × '+selected:'')+' · '+(!plan?.disabled?plan?.selectedOptions[0]?.textContent||mode:mode);
      const photo=product.querySelector('.pdp-image'),thumb=bar.querySelector('img');
      if(photo&&thumb&&thumb.src!==photo.src){thumb.src=photo.src;thumb.removeAttribute('srcset');thumb.alt=photo.alt;}
      reveal();
    };
    const reveal=()=>{
      const header=document.querySelector('.header');
      const offset=header&&['fixed','sticky'].includes(getComputedStyle(header).position)?Math.max(0,header.getBoundingClientRect().bottom):0;
      bar.style.setProperty('--mm-sticky-top',offset+'px');
      const mobile=matchMedia('(max-width:760px)').matches;const rect=add.getBoundingClientRect();const before=rect.top>=innerHeight-90;bar.dataset.beforeForm=String(mobile&&before);bar.hidden=mobile?(document.body.classList.contains('mm-gel-consent-open')||(!before&&rect.bottom>0)):form.getBoundingClientRect().bottom>offset;if(mobile&&before){button.textContent=bar.dataset.chooseLabel;button.disabled=false;}else{button.textContent=add.textContent;button.disabled=add.disabled;}
    };
    let queued=false;
    const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;reveal();});};
    const observer=new MutationObserver(sync);observer.observe(form,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    form.addEventListener('change',()=>queueMicrotask(sync));form.addEventListener('input',()=>queueMicrotask(sync));
    const edit=()=>{bar.hidden=true;form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});const choice=picks.length?form.querySelector('[data-mm-variant-choice]:checked'):form.querySelector('[name="mm_mode"]:checked');choice?.focus({preventScroll:true});};
    bar.querySelector('[data-mm-sticky-edit]').addEventListener('click',edit);
    button.addEventListener('click',()=>{if(bar.dataset.beforeForm==='true'){edit();return;}if(add.disabled)return;if(!form.checkValidity()){edit();form.reportValidity();return;}form.requestSubmit(add);});
    document.addEventListener('mm:gel-overlays',schedule);window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);
    sync();reveal();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise,{once:true});else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-help-actions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async event=>{
  const trigger=event.target.closest('[data-mm-open-help]');
  if(!trigger||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
  if(!window.GorgiasChat)return;
  event.preventDefault();
  let timeout;
  try{
    await Promise.race([window.GorgiasChat.init(),new Promise((_,reject)=>{timeout=setTimeout(()=>reject(new Error('Chat unavailable')),7000);})]);
    clearTimeout(timeout);window.GorgiasChat.open();
  }catch{clearTimeout(timeout);window.location.assign(trigger.href);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-journal"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>document.querySelectorAll('[data-mm-journal]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const search=root.querySelector('[data-mm-journal-search]'),cards=[...root.querySelectorAll('[data-mm-journal-item]')];root.querySelector('[data-mm-journal-control]').hidden=false;search.addEventListener('input',()=>{let count=0;cards.forEach(card=>{card.hidden=!card.dataset.search.toLocaleLowerCase().includes(search.value.trim().toLocaleLowerCase());if(!card.hidden)count++;});root.querySelector('[data-mm-journal-empty]').hidden=count!==0;});});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-klaviyo-treatment"] && !Shopify.designMode) return;
  try {
    (()=>{const boot=()=>{if(document.body.dataset.mmTeaserBound)return;document.body.dataset.mmTeaserBound='true';const footer=document.querySelector('footer')?.closest('.shopify-section')||document.querySelector('footer');if(footer)new IntersectionObserver(entries=>document.body.classList.toggle('mm-footer-in-view',entries[0].isIntersecting),{rootMargin:'40px 0px 0px'}).observe(footer);let raf=0;const update=()=>{raf=0;const frame=document.querySelector('#PBarNextFrameWrapper');const rect=frame?.getBoundingClientRect();const inset=rect&&rect.width&&rect.height&&rect.bottom>=innerHeight-2?innerHeight-Math.max(0,rect.top):0;if(document.body.style.getPropertyValue('--mm-preview-inset')!==inset+'px')document.body.style.setProperty('--mm-preview-inset',inset+'px');};const schedule=()=>{if(!raf)raf=requestAnimationFrame(update);};new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden']});addEventListener('resize',schedule);update();};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();})();
(() => {
  const boot = () => {
    if (!document.body.classList.contains('mm-theme') || document.body.dataset.mmSignupGuard) return;
    document.body.dataset.mmSignupGuard = 'true';
    const modalSelector = '[data-kl-scroll-locking-modal="true"]';
    const pending = new WeakMap();
    const dismissed = new WeakMap();
    let opener;
    let frame;
    const closing = modal => modal.style.animationName.includes('fadeout');
    const visible = modal => {
      const style = getComputedStyle(modal);
      return !modal.hasAttribute('data-mm-signup-dismissed') && style.display !== 'none' && style.visibility !== 'hidden' && modal.getClientRects().length;
    };
    const release = () => {
      if (![...document.querySelectorAll(modalSelector)].some(visible)) document.body.classList.remove('klaviyo-prevent-body-scrolling');
    };
    const reconcile = () => {
      frame = 0;
      document.querySelectorAll(modalSelector).forEach(modal => {
        if (!modal.querySelector('[data-testid="klaviyo-form-WumnVy"]')) return;
        if (!closing(modal)) {
          clearTimeout(pending.get(modal));
          pending.delete(modal);
          if (dismissed.has(modal)) {
            const previous = dismissed.get(modal);
            modal.removeAttribute('data-mm-signup-dismissed');
            modal.inert = previous.inert;
            if (previous.ariaHidden === null) modal.removeAttribute('aria-hidden');
            else modal.setAttribute('aria-hidden', previous.ariaHidden);
            dismissed.delete(modal);
          }
          return;
        }
        if (pending.has(modal) || dismissed.has(modal)) return;
        const style = getComputedStyle(modal);
        const duration = value => Math.max(0, ...value.split(',').map(part => parseFloat(part) * (part.trim().endsWith('ms') ? 1 : 1000)));
        const delay = duration(style.animationDuration) + duration(style.animationDelay) + 100;
        pending.set(modal, setTimeout(() => {
          pending.delete(modal);
          if (!modal.isConnected) { release(); return; }
          if (!closing(modal)) return;
          dismissed.set(modal, { inert: modal.inert, ariaHidden: modal.getAttribute('aria-hidden') });
          modal.setAttribute('data-mm-signup-dismissed', 'true');
          modal.setAttribute('aria-hidden', 'true');
          modal.inert = true;
          if (modal.contains(document.activeElement) && opener?.isConnected) opener.focus({ preventScroll: true });
          release();
        }, delay));
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(reconcile); };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-mm-klaviyo-open], .kl-teaser-WumnVy [role="button"]');
      if (trigger) opener = trigger;
    }, true);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    window.addEventListener('klaviyoForms', schedule);
    reconcile();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-market-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{const select=event.target.closest('.mm-market-form select[name="country_code"]');if(select)select.form.requestSubmit();});
document.addEventListener('submit',event=>{const form=event.target.closest('.mm-market-form');if(!form)return;let input=form.querySelector('[name="return_to"]');if(!input){input=document.createElement('input');input.type='hidden';input.name='return_to';form.append(input);}input.value=location.pathname+location.search;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-pdp-revision-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const jumpToReviews = trigger => {
    const target = trigger.closest('[data-mm-product]')?.querySelector('#reviews');
    if (!target) return;
    const header = document.querySelector('.header');
    const fixedHeader = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position);
    const offset = (fixedHeader ? header.getBoundingClientRect().height : 0) + 20;
    target.style.setProperty('--mm-reviews-offset', `${offset}px`);
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll:true});
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mm-review-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    jumpToReviews(trigger);
  }, true);
  document.addEventListener('keydown', event => {
    if (!['Enter',' '].includes(event.key) || !event.target.matches('[data-mm-review-trigger][role=link]')) return;
    event.preventDefault();
    jumpToReviews(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-product-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
  const cleanups = new WeakMap();
  const initialise = (root = document, reload = false) => {
    const widget = root.querySelector('#stamped-main-widget');
    if (!widget) return;
    cleanups.get(widget)?.();
    const section = widget.closest('.mm-reviews');
    const status = section.querySelector('[data-mm-reviews-status]');
    const fallback = section.querySelector('[data-mm-reviews-fallback]');
    status.hidden = false;
    fallback.hidden = true;
    // Stamped documents reloadUGC for widgets inserted by AJAX, including editor refreshes.
    if (reload && typeof window.StampedFn?.reloadUGC === 'function') {
      window.StampedFn.reloadUGC();
    }
    const check = () => {
      if (widget.querySelector('.stamped-container')) {
        status.hidden = true;
        fallback.hidden = true;
        return true;
      }
      return false;
    };
    if (check()) return;
    const observer = new MutationObserver(() => { if (check()) observer.disconnect(); });
    observer.observe(widget, {childList:true,subtree:true});
    const timer = window.setTimeout(() => { if (!check()) { status.hidden=true;fallback.hidden=false; } }, 15000);
    cleanups.set(widget, () => { observer.disconnect(); window.clearTimeout(timer); cleanups.delete(widget); });
  };
  document.addEventListener('shopify:section:load', event => initialise(event.target, true));
  document.addEventListener('shopify:section:unload', event => {
    const widget = event.target.querySelector('#stamped-main-widget');
    if (widget) cleanups.get(widget)?.();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), {once:true});
  else initialise();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-range-explorer"] && !Shopify.designMode) return;
  try {
    (() => {
 const init = () => document.querySelectorAll('[data-mm-range]').forEach(root => {
  if(root.dataset.ready) return; root.dataset.ready='true';
  const cards=[...root.querySelectorAll('[data-mm-range-item]')], format=root.querySelector('[data-mm-range-format]'),search=root.querySelector('[data-mm-range-search]'),stock=root.querySelector('[data-mm-range-stock]');
  [...new Set(cards.map(card=>card.dataset.format).filter(Boolean))].sort().forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;format.append(option);});
  const update=()=>{let count=0;const query=search.value.trim().toLocaleLowerCase();cards.forEach(card=>{const match=(!format.value||card.dataset.format===format.value)&&(!stock.checked||card.dataset.available==='true')&&card.dataset.search.toLocaleLowerCase().includes(query);card.hidden=!match;if(match)count++;});root.querySelector('[data-mm-range-count]').textContent=count+' '+root.dataset.countLabel;root.querySelector('[data-mm-range-empty]').hidden=count!==0;};
  root.querySelector('[data-mm-range-controls]').hidden=false;
  [format,stock].forEach(control=>control.addEventListener('change',update));search.addEventListener('input',update);
  root.querySelector('[data-mm-range-clear]').addEventListener('click',()=>{format.value='';search.value='';stock.checked=false;update();format.focus();});update();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-range-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const init=scope=>scope.querySelectorAll('[data-mm-range-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.addEventListener('click',e=>{const button=e.target.closest('[data-mm-range-select]');if(!button)return;root.querySelectorAll('[data-mm-range-select]').forEach(b=>{const selected=b===button;b.classList.toggle('selected',selected);b.setAttribute('aria-pressed',selected?'true':'false');});root.querySelectorAll('[data-mm-range-panel]').forEach(p=>p.hidden=p.dataset.mmRangePanel!==button.dataset.mmRangeSelect);});});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-sticky-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise=()=>document.querySelectorAll('[data-mm-sticky-purchase]').forEach(bar=>{
    if(bar.dataset.ready)return;bar.dataset.ready='true';
    const product=bar.closest('[data-mm-product]'),form=product.querySelector('.mm-product-form'),add=form?.querySelector('[data-mm-add]');
    if(!form||!add)return;
    const picks=[...bar.querySelectorAll('[data-mm-sticky-variant]')];
    picks.forEach(pick=>pick.addEventListener('click',()=>{const original=form.querySelector('[data-mm-variant]');original.value=pick.dataset.mmStickyVariant;original.dispatchEvent(new Event('change',{bubbles:true}));}));
    bar.querySelectorAll('[data-mm-sticky-mode]').forEach(pick=>pick.addEventListener('click',()=>{const original=form.querySelector('[name="mm_mode"][value="'+pick.dataset.mmStickyMode+'"]');if(!original||original.disabled)return;original.checked=true;original.dispatchEvent(new Event('change',{bubbles:true}));}));
    const stickyPlan=bar.querySelector('[data-mm-sticky-plan]');stickyPlan.addEventListener('change',()=>{const original=form.querySelector('[data-mm-plan]');original.value=stickyPlan.value;original.dispatchEvent(new Event('change',{bubbles:true}));});
    const button=bar.querySelector('[data-mm-sticky-add]'),summary=bar.querySelector('[data-mm-sticky-summary]');
    const sync=()=>{
      button.textContent=add.textContent;button.disabled=add.disabled;
      const variant=form.querySelector('[data-mm-variant]'),plan=form.querySelector('[data-mm-plan]'),quantity=form.querySelector('[name="quantity"]');
      picks.forEach(pick=>pick.setAttribute('aria-pressed',String(pick.dataset.mmStickyVariant===variant.value)));
      bar.querySelectorAll('[data-mm-sticky-mode]').forEach(pick=>{const mode=pick.dataset.mmStickyMode,original=form.querySelector('[name="mm_mode"][value="'+mode+'"]');pick.hidden=!original||original.closest('label').hidden;pick.disabled=!!original?.disabled;pick.setAttribute('aria-pressed',String(!!original?.checked));});
      bar.querySelector('[data-mm-sticky-once-price]').textContent=form.querySelector('[data-mm-once-price]')?.textContent||'';
      bar.querySelector('[data-mm-sticky-sub-price]').textContent=form.querySelector('[data-mm-sub-price]')?.textContent||'';
      bar.querySelector('[data-mm-sticky-plan-wrap]').hidden=!plan||plan.disabled||[...plan.options].filter(option=>option.value).length<=1;
      const saving=form.querySelector('[data-mm-sub-saving]'),badge=bar.querySelector('[data-mm-sticky-saving]');
      badge.textContent=saving?.textContent.trim()||'';badge.hidden=!saving||saving.hidden;
      if(plan){if(stickyPlan.innerHTML!==plan.innerHTML)stickyPlan.innerHTML=plan.innerHTML;stickyPlan.value=plan.value;stickyPlan.disabled=plan.disabled;}

      const selected=JSON.parse(product.querySelector('[data-mm-product-data]').textContent).variants.find(item=>String(item.id)===variant?.value)?.title||'';
      const checked=form.querySelector('[name="mm_mode"]:checked');
      const mode=checked?.value==='subscribe'?form.querySelector('[data-mm-sub-heading]')?.textContent.trim()||'':checked?.closest('label')?.querySelector('strong')?.textContent.trim()||'';
      summary.textContent=(quantity?.value||'1')+(selected?' × '+selected:'')+' · '+mode;
      const photo=product.querySelector('.pdp-image'),thumb=bar.querySelector('img');
      if(photo&&thumb&&thumb.src!==photo.src){thumb.src=photo.src;thumb.removeAttribute('srcset');thumb.alt=photo.alt;}
    };
    const reveal=()=>{
      const header=document.querySelector('.header');
      const offset=header&&['fixed','sticky'].includes(getComputedStyle(header).position)?Math.max(0,header.getBoundingClientRect().bottom):0;
      bar.style.setProperty('--mm-sticky-top',offset+'px');
      bar.hidden=form.getBoundingClientRect().bottom>offset;
    };
    let queued=false;
    const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;reveal();});};
    const observer=new MutationObserver(sync);observer.observe(form,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    form.addEventListener('change',()=>queueMicrotask(sync));form.addEventListener('input',()=>queueMicrotask(sync));
    const edit=()=>{bar.hidden=true;form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});const choice=picks.length?form.querySelector('[data-mm-variant-choice]:checked'):form.querySelector('[name="mm_mode"]:checked');choice?.focus({preventScroll:true});};
    bar.querySelector('[data-mm-sticky-edit]').addEventListener('click',edit);
    button.addEventListener('click',()=>{if(add.disabled)return;if(!form.checkValidity()){edit();form.reportValidity();return;}form.requestSubmit(add);});
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);
    sync();reveal();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise,{once:true});else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-support-explorer"] && !Shopify.designMode) return;
  try {
    (() => {
 const init=()=>document.querySelectorAll('.mm-support-layout:not(.mm-compare-layout)').forEach(layout=>{
  const article=layout.querySelector('.mm-support-content');if(!article||article.dataset.explorer)return;article.dataset.explorer='true';
  const sections=[...article.querySelectorAll(':scope > section')].filter(section=>section.querySelector('h2'));
  const nav=document.createElement('nav');nav.className='mm-help-topics';nav.setAttribute('aria-label',layout.querySelector('.mm-support-nav')?.getAttribute('aria-label')||'Help');
  sections.forEach((section,index)=>{const heading=section.querySelector('h2');if(!heading.id)heading.id='mm-help-topic-'+index;heading.tabIndex=-1;const link=document.createElement('a');link.href='#'+heading.id;const number=document.createElement('span');number.className='mm-help-topic-icon';number.textContent=String(index+1).padStart(2,'0');number.setAttribute('aria-hidden','true');const text=document.createElement('strong');text.textContent=heading.textContent;link.append(number,text);link.addEventListener('click',()=>requestAnimationFrame(()=>heading.focus({preventScroll:true})));nav.append(link);section.classList.add('mm-help-panel');});
  if(!sections.length){[...layout.querySelectorAll('.mm-support-nav a')].filter(a=>/support-faqs|mm-delivery|mm-returns/.test(a.href)).forEach(source=>{const link=source.cloneNode(true);link.removeAttribute('aria-current');nav.append(link);});}
  if(nav.children.length){const target=article.querySelector(':scope > section,:scope > .mm-gorgias-contact,:scope > form,:scope > .mm-cookie-preferences');if(target)article.insertBefore(nav,target);else article.append(nav);}
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-support-nav"] && !Shopify.designMode) return;
  try {
    const alignSupportNavigation = (scope = document) => {
    if (!window.matchMedia('(max-width: 1000px)').matches) return;
    scope.querySelectorAll('.mm-support-nav').forEach((nav) => {
      const current = nav.querySelector('[aria-current="page"]');
      if (!current) return;
      const navBounds = nav.getBoundingClientRect();
      const currentBounds = current.getBoundingClientRect();
      if (currentBounds.left < navBounds.left || currentBounds.right > navBounds.right) {
        nav.scrollLeft += currentBounds.left - navBounds.left - 3;
      }
    });
  };
  alignSupportNavigation();
  document.addEventListener('shopify:section:load', (event) => alignSupportNavigation(event.target));
  window.matchMedia('(max-width: 1000px)').addEventListener('change', () => alignSupportNavigation());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-yield-calculator"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mm-yield-calc]').forEach(form=>{
  const amount=form.elements.amount;
  const output=form.querySelector('[data-mm-yield-result]');
  form.addEventListener('submit',event=>{
    event.preventDefault();
    const value=amount.valueAsNumber;
    if(!Number.isFinite(value)||value<=0){amount.setAttribute('aria-invalid','true');output.textContent=form.dataset.invalid;amount.focus();return;}
    amount.removeAttribute('aria-invalid');
    const us=form.elements.unit.value==='us';
    const grams=us?value*28.349523125:value;
    const ml=grams/150*4000;
    const result=us?ml/29.5735295625:ml;
    output.textContent=form.dataset.result.replace('[[amount]]',result.toLocaleString(document.documentElement.lang,{maximumFractionDigits:2})).replace('[[unit]]',us?'US fl oz':'ml');
  });
  form.addEventListener('input',()=>{output.textContent='';amount.removeAttribute('aria-invalid');});
});
  } catch(e) { console.error(e); }
})();

})();
